import React from "react";
import { Menu } from "lucide-react";

const Header = ({ isSidebarOpen, setIsSidebarOpen }) => {
  return (
    <header className="md:hidden sticky top-0 z-20 w-full bg-white border-b border-zinc-200/80 flex items-center h-14 px-4 shadow-xs">
      <div className="flex justify-between items-center w-full">
        {/* Mobile menu toggle */}
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className="p-1.5 rounded-lg text-zinc-700 hover:text-zinc-950 hover:bg-zinc-100 transition-colors"
          aria-label="Toggle sidebar"
        >
          <Menu className="h-6 w-6" />
        </button>

        <h1 className="text-base font-extrabold text-zinc-900 ml-3 tracking-tight">
          GlobalTrade<span className="text-amber-600">Pro</span>
        </h1>

        <div className="flex-1" />
      </div>
    </header>
  );
};

export default Header;
